<template>
  <div class="locale-changer">
    <a href="#" @click.prevent="setLocale('de')">de</a>
    <div class="divider-line">|</div>
    <a href="#" @click.prevent="setLocale('en')">en</a>
  </div>
</template>

<script>
export default {
  data () {
    return {
      langs: ['de', 'en'] }
  },
  methods: {
  setLocale(locale) {
    this.$i18n.locale = locale
    this.$router.push({
        params: {lang: locale}
    })
  }
}
}
</script>
